<template>
  <label class="label truncate" for="" v-if="isRequired">
    <span v-if="redCheck" class="icon has-text-primary is-small is-margin-right-xsmall" :class="[checkValue ? 'has-text-success' : 'has-text-danger']">
      <i class="fas fa-check-circle"></i>
    </span>
    <span v-else class="icon has-text-primary is-small is-margin-right-xsmall" :class="[checkValue ? 'has-text-success' : 'has-text-primary']">
      <i class="fas fa-check-circle"></i>
    </span>
    <span class="">
      <span>{{label}}
        <span class="has-text-weight-light">{{sublabel}}</span>
        <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
      </span>
    </span>
    
    <slot></slot>
  </label>
  <label for="" v-else class="label">
    <div v-if='greenCheck' >
      <span class="icon has-text-primary is-small is-margin-right-xsmall has-text-success">
        <i class="fas fa-check-circle"></i>
      </span>
      <span class=""><span>{{label}} <span class="has-text-weight-light">{{sublabel}}</span></span></span>
    </div>
    <span v-else class="truncate">
      <span>{{label}}
        <span class="has-text-weight-light">{{sublabel}}</span>
        <i class="is-padding-left-xxsmall fas fa-rss fa-xs" v-if="fromFlux"></i>
      </span>
    </span>
    <slot></slot>
  </label>
</template>

<script>
  import { isNil, isEmpty, isString } from 'lodash'

  export default {
    name: 'RLabel',
    props: {
      redCheck: Boolean,
      label: String,
      sublabel: String,
      value: null,
      isRequired: {
        type: Boolean,
        default: true
      },
      greenCheck: Boolean,
      fromFlux: Boolean
    },
    computed: {
      checkValue () {
        return (isString(this.value) || Array.isArray(this.value)) ? this.value.length : (!isNil(this.value) || !isEmpty(this.value))
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/utils/RLabel.vue